import axios from 'axios';
import mixpanel from 'mixpanel-browser';

import { CTAInteractionTrackingEvents } from '@revelio/core';

import { environment } from '../../environment';

const isProduction = window.location.host.startsWith('account.reveliolabs.com');

export const resendVerificationEmail = async ({
  email,
  csrfToken,
  flowId,
}: {
  email: string;
  csrfToken: string;
  flowId: string;
}) => {
  try {
    const response = await axios.post(
      `${environment.PUBLIC_ORY_KRATOS_URL}/self-service/verification?flow=${flowId}`,
      {
        method: 'code',
        email,
        csrf_token: csrfToken,
      },
      {
        withCredentials: true,
        xsrfCookieName: 'x-surf-token',
        xsrfHeaderName: 'x-surf-token',
      }
    );

    if (isProduction) {
      mixpanel.track(CTAInteractionTrackingEvents.RESEND_VERIFICATION_EMAIL, {
        source: 'dashboard',
      });
    }

    return response.data;
  } catch (error) {
    console.error('Error resending verification email:', error);
    throw error;
  }
};
